export default function Blog() {
  return <div>Coming Soon</div>;
}
